var k = {}, V;
function ge() {
  return V || (V = 1, function(i) {
    i.aliasToReal = {
      // Lodash aliases.
      each: "forEach",
      eachRight: "forEachRight",
      entries: "toPairs",
      entriesIn: "toPairsIn",
      extend: "assignIn",
      extendAll: "assignInAll",
      extendAllWith: "assignInAllWith",
      extendWith: "assignInWith",
      first: "head",
      // Methods that are curried variants of others.
      conforms: "conformsTo",
      matches: "isMatch",
      property: "get",
      // Ramda aliases.
      __: "placeholder",
      F: "stubFalse",
      T: "stubTrue",
      all: "every",
      allPass: "overEvery",
      always: "constant",
      any: "some",
      anyPass: "overSome",
      apply: "spread",
      assoc: "set",
      assocPath: "set",
      complement: "negate",
      compose: "flowRight",
      contains: "includes",
      dissoc: "unset",
      dissocPath: "unset",
      dropLast: "dropRight",
      dropLastWhile: "dropRightWhile",
      equals: "isEqual",
      identical: "eq",
      indexBy: "keyBy",
      init: "initial",
      invertObj: "invert",
      juxt: "over",
      omitAll: "omit",
      nAry: "ary",
      path: "get",
      pathEq: "matchesProperty",
      pathOr: "getOr",
      paths: "at",
      pickAll: "pick",
      pipe: "flow",
      pluck: "map",
      prop: "get",
      propEq: "matchesProperty",
      propOr: "getOr",
      props: "at",
      symmetricDifference: "xor",
      symmetricDifferenceBy: "xorBy",
      symmetricDifferenceWith: "xorWith",
      takeLast: "takeRight",
      takeLastWhile: "takeRightWhile",
      unapply: "rest",
      unnest: "flatten",
      useWith: "overArgs",
      where: "conformsTo",
      whereEq: "isMatch",
      zipObj: "zipObject"
    }, i.aryMethod = {
      1: [
        "assignAll",
        "assignInAll",
        "attempt",
        "castArray",
        "ceil",
        "create",
        "curry",
        "curryRight",
        "defaultsAll",
        "defaultsDeepAll",
        "floor",
        "flow",
        "flowRight",
        "fromPairs",
        "invert",
        "iteratee",
        "memoize",
        "method",
        "mergeAll",
        "methodOf",
        "mixin",
        "nthArg",
        "over",
        "overEvery",
        "overSome",
        "rest",
        "reverse",
        "round",
        "runInContext",
        "spread",
        "template",
        "trim",
        "trimEnd",
        "trimStart",
        "uniqueId",
        "words",
        "zipAll"
      ],
      2: [
        "add",
        "after",
        "ary",
        "assign",
        "assignAllWith",
        "assignIn",
        "assignInAllWith",
        "at",
        "before",
        "bind",
        "bindAll",
        "bindKey",
        "chunk",
        "cloneDeepWith",
        "cloneWith",
        "concat",
        "conformsTo",
        "countBy",
        "curryN",
        "curryRightN",
        "debounce",
        "defaults",
        "defaultsDeep",
        "defaultTo",
        "delay",
        "difference",
        "divide",
        "drop",
        "dropRight",
        "dropRightWhile",
        "dropWhile",
        "endsWith",
        "eq",
        "every",
        "filter",
        "find",
        "findIndex",
        "findKey",
        "findLast",
        "findLastIndex",
        "findLastKey",
        "flatMap",
        "flatMapDeep",
        "flattenDepth",
        "forEach",
        "forEachRight",
        "forIn",
        "forInRight",
        "forOwn",
        "forOwnRight",
        "get",
        "groupBy",
        "gt",
        "gte",
        "has",
        "hasIn",
        "includes",
        "indexOf",
        "intersection",
        "invertBy",
        "invoke",
        "invokeMap",
        "isEqual",
        "isMatch",
        "join",
        "keyBy",
        "lastIndexOf",
        "lt",
        "lte",
        "map",
        "mapKeys",
        "mapValues",
        "matchesProperty",
        "maxBy",
        "meanBy",
        "merge",
        "mergeAllWith",
        "minBy",
        "multiply",
        "nth",
        "omit",
        "omitBy",
        "overArgs",
        "pad",
        "padEnd",
        "padStart",
        "parseInt",
        "partial",
        "partialRight",
        "partition",
        "pick",
        "pickBy",
        "propertyOf",
        "pull",
        "pullAll",
        "pullAt",
        "random",
        "range",
        "rangeRight",
        "rearg",
        "reject",
        "remove",
        "repeat",
        "restFrom",
        "result",
        "sampleSize",
        "some",
        "sortBy",
        "sortedIndex",
        "sortedIndexOf",
        "sortedLastIndex",
        "sortedLastIndexOf",
        "sortedUniqBy",
        "split",
        "spreadFrom",
        "startsWith",
        "subtract",
        "sumBy",
        "take",
        "takeRight",
        "takeRightWhile",
        "takeWhile",
        "tap",
        "throttle",
        "thru",
        "times",
        "trimChars",
        "trimCharsEnd",
        "trimCharsStart",
        "truncate",
        "union",
        "uniqBy",
        "uniqWith",
        "unset",
        "unzipWith",
        "without",
        "wrap",
        "xor",
        "zip",
        "zipObject",
        "zipObjectDeep"
      ],
      3: [
        "assignInWith",
        "assignWith",
        "clamp",
        "differenceBy",
        "differenceWith",
        "findFrom",
        "findIndexFrom",
        "findLastFrom",
        "findLastIndexFrom",
        "getOr",
        "includesFrom",
        "indexOfFrom",
        "inRange",
        "intersectionBy",
        "intersectionWith",
        "invokeArgs",
        "invokeArgsMap",
        "isEqualWith",
        "isMatchWith",
        "flatMapDepth",
        "lastIndexOfFrom",
        "mergeWith",
        "orderBy",
        "padChars",
        "padCharsEnd",
        "padCharsStart",
        "pullAllBy",
        "pullAllWith",
        "rangeStep",
        "rangeStepRight",
        "reduce",
        "reduceRight",
        "replace",
        "set",
        "slice",
        "sortedIndexBy",
        "sortedLastIndexBy",
        "transform",
        "unionBy",
        "unionWith",
        "update",
        "xorBy",
        "xorWith",
        "zipWith"
      ],
      4: [
        "fill",
        "setWith",
        "updateWith"
      ]
    }, i.aryRearg = {
      2: [1, 0],
      3: [2, 0, 1],
      4: [3, 2, 0, 1]
    }, i.iterateeAry = {
      dropRightWhile: 1,
      dropWhile: 1,
      every: 1,
      filter: 1,
      find: 1,
      findFrom: 1,
      findIndex: 1,
      findIndexFrom: 1,
      findKey: 1,
      findLast: 1,
      findLastFrom: 1,
      findLastIndex: 1,
      findLastIndexFrom: 1,
      findLastKey: 1,
      flatMap: 1,
      flatMapDeep: 1,
      flatMapDepth: 1,
      forEach: 1,
      forEachRight: 1,
      forIn: 1,
      forInRight: 1,
      forOwn: 1,
      forOwnRight: 1,
      map: 1,
      mapKeys: 1,
      mapValues: 1,
      partition: 1,
      reduce: 2,
      reduceRight: 2,
      reject: 1,
      remove: 1,
      some: 1,
      takeRightWhile: 1,
      takeWhile: 1,
      times: 1,
      transform: 2
    }, i.iterateeRearg = {
      mapKeys: [1],
      reduceRight: [1, 0]
    }, i.methodRearg = {
      assignInAllWith: [1, 0],
      assignInWith: [1, 2, 0],
      assignAllWith: [1, 0],
      assignWith: [1, 2, 0],
      differenceBy: [1, 2, 0],
      differenceWith: [1, 2, 0],
      getOr: [2, 1, 0],
      intersectionBy: [1, 2, 0],
      intersectionWith: [1, 2, 0],
      isEqualWith: [1, 2, 0],
      isMatchWith: [2, 1, 0],
      mergeAllWith: [1, 0],
      mergeWith: [1, 2, 0],
      padChars: [2, 1, 0],
      padCharsEnd: [2, 1, 0],
      padCharsStart: [2, 1, 0],
      pullAllBy: [2, 1, 0],
      pullAllWith: [2, 1, 0],
      rangeStep: [1, 2, 0],
      rangeStepRight: [1, 2, 0],
      setWith: [3, 1, 2, 0],
      sortedIndexBy: [2, 1, 0],
      sortedLastIndexBy: [2, 1, 0],
      unionBy: [1, 2, 0],
      unionWith: [1, 2, 0],
      updateWith: [3, 1, 2, 0],
      xorBy: [1, 2, 0],
      xorWith: [1, 2, 0],
      zipWith: [1, 2, 0]
    }, i.methodSpread = {
      assignAll: { start: 0 },
      assignAllWith: { start: 0 },
      assignInAll: { start: 0 },
      assignInAllWith: { start: 0 },
      defaultsAll: { start: 0 },
      defaultsDeepAll: { start: 0 },
      invokeArgs: { start: 2 },
      invokeArgsMap: { start: 2 },
      mergeAll: { start: 0 },
      mergeAllWith: { start: 0 },
      partial: { start: 1 },
      partialRight: { start: 1 },
      without: { start: 1 },
      zipAll: { start: 0 }
    }, i.mutate = {
      array: {
        fill: !0,
        pull: !0,
        pullAll: !0,
        pullAllBy: !0,
        pullAllWith: !0,
        pullAt: !0,
        remove: !0,
        reverse: !0
      },
      object: {
        assign: !0,
        assignAll: !0,
        assignAllWith: !0,
        assignIn: !0,
        assignInAll: !0,
        assignInAllWith: !0,
        assignInWith: !0,
        assignWith: !0,
        defaults: !0,
        defaultsAll: !0,
        defaultsDeep: !0,
        defaultsDeepAll: !0,
        merge: !0,
        mergeAll: !0,
        mergeAllWith: !0,
        mergeWith: !0
      },
      set: {
        set: !0,
        setWith: !0,
        unset: !0,
        update: !0,
        updateWith: !0
      }
    }, i.realToAlias = function() {
      var E = Object.prototype.hasOwnProperty, R = i.aliasToReal, W = {};
      for (var A in R) {
        var I = R[A];
        E.call(W, I) ? W[I].push(A) : W[I] = [A];
      }
      return W;
    }(), i.remap = {
      assignAll: "assign",
      assignAllWith: "assignWith",
      assignInAll: "assignIn",
      assignInAllWith: "assignInWith",
      curryN: "curry",
      curryRightN: "curryRight",
      defaultsAll: "defaults",
      defaultsDeepAll: "defaultsDeep",
      findFrom: "find",
      findIndexFrom: "findIndex",
      findLastFrom: "findLast",
      findLastIndexFrom: "findLastIndex",
      getOr: "get",
      includesFrom: "includes",
      indexOfFrom: "indexOf",
      invokeArgs: "invoke",
      invokeArgsMap: "invokeMap",
      lastIndexOfFrom: "lastIndexOf",
      mergeAll: "merge",
      mergeAllWith: "mergeWith",
      padChars: "pad",
      padCharsEnd: "padEnd",
      padCharsStart: "padStart",
      propertyOf: "get",
      rangeStep: "range",
      rangeStepRight: "rangeRight",
      restFrom: "rest",
      spreadFrom: "spread",
      trimChars: "trim",
      trimCharsEnd: "trimEnd",
      trimCharsStart: "trimStart",
      zipAll: "zip"
    }, i.skipFixed = {
      castArray: !0,
      flow: !0,
      flowRight: !0,
      iteratee: !0,
      mixin: !0,
      rearg: !0,
      runInContext: !0
    }, i.skipRearg = {
      add: !0,
      assign: !0,
      assignIn: !0,
      bind: !0,
      bindKey: !0,
      concat: !0,
      difference: !0,
      divide: !0,
      eq: !0,
      gt: !0,
      gte: !0,
      isEqual: !0,
      lt: !0,
      lte: !0,
      matchesProperty: !0,
      merge: !0,
      multiply: !0,
      overArgs: !0,
      partial: !0,
      partialRight: !0,
      propertyOf: !0,
      random: !0,
      range: !0,
      rangeRight: !0,
      subtract: !0,
      zip: !0,
      zipObject: !0,
      zipObjectDeep: !0
    };
  }(k)), k;
}
var M, G;
function ce() {
  return G || (G = 1, M = {}), M;
}
var L, J;
function me() {
  if (J) return L;
  J = 1;
  var i = ge(), E = ce(), R = Array.prototype.push;
  function W(s, o) {
    return o == 2 ? function(u, l) {
      return s.apply(void 0, arguments);
    } : function(u) {
      return s.apply(void 0, arguments);
    };
  }
  function A(s, o) {
    return o == 2 ? function(u, l) {
      return s(u, l);
    } : function(u) {
      return s(u);
    };
  }
  function I(s) {
    for (var o = s ? s.length : 0, u = Array(o); o--; )
      u[o] = s[o];
    return u;
  }
  function Q(s) {
    return function(o) {
      return s({}, o);
    };
  }
  function X(s, o) {
    return function() {
      for (var u = arguments.length, l = u - 1, f = Array(u); u--; )
        f[u] = arguments[u];
      var x = f[o], c = f.slice(0, o);
      return x && R.apply(c, x), o != l && R.apply(c, f.slice(o + 1)), s.apply(this, c);
    };
  }
  function F(s, o) {
    return function() {
      var u = arguments.length;
      if (u) {
        for (var l = Array(u); u--; )
          l[u] = arguments[u];
        var f = l[0] = o.apply(void 0, l);
        return s.apply(void 0, l), f;
      }
    };
  }
  function C(s, o, u, l) {
    var f = typeof o == "function", x = o === Object(o);
    if (x && (l = u, u = o, o = void 0), u == null)
      throw new TypeError();
    l || (l = {});
    var c = {
      cap: "cap" in l ? l.cap : !0,
      curry: "curry" in l ? l.curry : !0,
      fixed: "fixed" in l ? l.fixed : !0,
      immutable: "immutable" in l ? l.immutable : !0,
      rearg: "rearg" in l ? l.rearg : !0
    }, Y = f ? u : E, q = "curry" in l && l.curry, Z = "fixed" in l && l.fixed, $ = "rearg" in l && l.rearg, S = f ? u.runInContext() : void 0, h = f ? u : {
      ary: s.ary,
      assign: s.assign,
      clone: s.clone,
      curry: s.curry,
      forEach: s.forEach,
      isArray: s.isArray,
      isError: s.isError,
      isFunction: s.isFunction,
      isWeakMap: s.isWeakMap,
      iteratee: s.iteratee,
      keys: s.keys,
      rearg: s.rearg,
      toInteger: s.toInteger,
      toPath: s.toPath
    }, ee = h.ary, j = h.assign, P = h.clone, O = h.curry, m = h.forEach, re = h.isArray, te = h.isError, w = h.isFunction, ae = h.isWeakMap, B = h.keys, D = h.rearg, ne = h.toInteger, ie = h.toPath, z = B(i.aryMethod), se = {
      castArray: function(t) {
        return function() {
          var e = arguments[0];
          return re(e) ? t(I(e)) : t.apply(void 0, arguments);
        };
      },
      iteratee: function(t) {
        return function() {
          var e = arguments[0], r = arguments[1], a = t(e, r), n = a.length;
          return c.cap && typeof r == "number" ? (r = r > 2 ? r - 2 : 1, n && n <= r ? a : A(a, r)) : a;
        };
      },
      mixin: function(t) {
        return function(e) {
          var r = this;
          if (!w(r))
            return t(r, Object(e));
          var a = [];
          return m(B(e), function(n) {
            w(e[n]) && a.push([n, r.prototype[n]]);
          }), t(r, Object(e)), m(a, function(n) {
            var d = n[1];
            w(d) ? r.prototype[n[0]] = d : delete r.prototype[n[0]];
          }), r;
        };
      },
      nthArg: function(t) {
        return function(e) {
          var r = e < 0 ? 1 : ne(e) + 1;
          return O(t(e), r);
        };
      },
      rearg: function(t) {
        return function(e, r) {
          var a = r ? r.length : 0;
          return O(t(e, r), a);
        };
      },
      runInContext: function(t) {
        return function(e) {
          return C(s, t(e), l);
        };
      }
    };
    function le(t, e) {
      if (c.cap) {
        var r = i.iterateeRearg[t];
        if (r)
          return fe(e, r);
        var a = !f && i.iterateeAry[t];
        if (a)
          return he(e, a);
      }
      return e;
    }
    function ue(t, e, r) {
      return q || c.curry && r > 1 ? O(e, r) : e;
    }
    function T(t, e, r) {
      if (c.fixed && (Z || !i.skipFixed[t])) {
        var a = i.methodSpread[t], n = a && a.start;
        return n === void 0 ? ee(e, r) : X(e, n);
      }
      return e;
    }
    function _(t, e, r) {
      return c.rearg && r > 1 && ($ || !i.skipRearg[t]) ? D(e, i.methodRearg[t] || i.aryRearg[r]) : e;
    }
    function oe(t, e) {
      e = ie(e);
      for (var r = -1, a = e.length, n = a - 1, d = P(Object(t)), y = d; y != null && ++r < a; ) {
        var g = e[r], v = y[g];
        v != null && !(w(v) || te(v) || ae(v)) && (y[g] = P(r == n ? v : Object(v))), y = y[g];
      }
      return d;
    }
    function de(t) {
      return p.runInContext.convert(t)(void 0);
    }
    function N(t, e) {
      var r = i.aliasToReal[t] || t, a = i.remap[r] || r, n = l;
      return function(d) {
        var y = f ? S : h, g = f ? S[a] : e, v = j(j({}, n), d);
        return C(y, r, g, v);
      };
    }
    function he(t, e) {
      return K(t, function(r) {
        return typeof r == "function" ? A(r, e) : r;
      });
    }
    function fe(t, e) {
      return K(t, function(r) {
        var a = e.length;
        return W(D(A(r, a), e), a);
      });
    }
    function K(t, e) {
      return function() {
        var r = arguments.length;
        if (!r)
          return t();
        for (var a = Array(r); r--; )
          a[r] = arguments[r];
        var n = c.rearg ? 0 : r - 1;
        return a[n] = e(a[n]), t.apply(void 0, a);
      };
    }
    function H(t, e, r) {
      var a, n = i.aliasToReal[t] || t, d = e, y = se[n];
      return y ? d = y(e) : c.immutable && (i.mutate.array[n] ? d = F(e, I) : i.mutate.object[n] ? d = F(e, Q(e)) : i.mutate.set[n] && (d = F(e, oe))), m(z, function(g) {
        return m(i.aryMethod[g], function(v) {
          if (n == v) {
            var U = i.methodSpread[n], pe = U && U.afterRearg;
            return a = pe ? T(n, _(n, d, g), g) : _(n, T(n, d, g), g), a = le(n, a), a = ue(n, a, g), !1;
          }
        }), !a;
      }), a || (a = d), a == e && (a = q ? O(a, 1) : function() {
        return e.apply(this, arguments);
      }), a.convert = N(n, e), a.placeholder = e.placeholder = r, a;
    }
    if (!x)
      return H(o, u, Y);
    var p = u, b = [];
    return m(z, function(t) {
      m(i.aryMethod[t], function(e) {
        var r = p[i.remap[e] || e];
        r && b.push([e, H(e, r, p)]);
      });
    }), m(B(p), function(t) {
      var e = p[t];
      if (typeof e == "function") {
        for (var r = b.length; r--; )
          if (b[r][0] == t)
            return;
        e.convert = N(t, e), b.push([t, e]);
      }
    }), m(b, function(t) {
      p[t[0]] = t[1];
    }), p.convert = de, p.placeholder = p, m(B(p), function(t) {
      m(i.realToAlias[t] || [], function(e) {
        p[e] = p[t];
      });
    }), p;
  }
  return L = C, L;
}
export {
  me as a,
  ce as r
};
